export default "__VITE_ASSET__BjPNjcPg__"